module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec04_2027b0866c1e3683d9066dd835fd0e73.jpg";